// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"225":"c07d1f79","838":"65937e22"}[chunkId] + ".js";
};